import { useQuery } from "@tanstack/react-query"

import { getProfessionalProfile } from "services/professionals/getProfessionalProfile"

export function useGetProfessionalProfile(professionalSlug: string) {
  const { data, isLoading, error } = useQuery({
    queryKey: ['professionalProfile'],
    queryFn: () => getProfessionalProfile(professionalSlug),
    enabled: !!professionalSlug,
  })

  if (!data || error) {
    return {
      professionalProfile: null,
      professionalProfileLoading: isLoading,
    }
  }

  return {
    professionalProfile: data,
    professionalProfileLoading: isLoading,
  }
}